<script setup lang="ts">
import type { IRTImpactMap } from "./IRTImpactMap";
import ImpactDemographics from "../Impact/ImpactDemographics.vue";
import ImpactNoData from "../Impact/ImpactNoData.vue";
import { useImpactStore } from "~/stores/impact";

defineProps<IRTImpactMap>();

const impactStore = useImpactStore();

const showImpactDemographics = computed(() => {
  return !!(
    impactStore.geolocations?.length ||
    impactStore.topCountries?.length ||
    impactStore.topReferrers?.length
  );
});
</script>
<template>
  <div
    class="RTImpactMap"
    :class="{ 'RTImpactMap--noData': !showImpactDemographics }">
    <ImpactDemographics
      v-if="showImpactDemographics"
      :geo-locations="impactStore.geolocations || []"
      :countries="impactStore.topCountries || []"
      :referrers="impactStore.topReferrers || []"
      :loading="demographicsLoading"
      :error="demographicsErrors" />

    <ImpactNoData v-else />
  </div>
</template>

<style lang="scss">
.RTImpactMap.RTImpactMap--noData {
  min-width: 100%;
}
</style>
